
import axios from 'axios'
import CheckChoice from '@/components/Subjects/CheckChoice'
import Group from 'vux/src/components/group/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import XHeader from 'vux/src/components/x-header/index.vue'
import Grid from 'vux/src/components/grid/grid.vue'
import GridItem from 'vux/src/components/grid/grid-item.vue'
import Divider from 'vux/src/components/divider/index.vue'
import Card from 'vux/src/components/card/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import XDialog from 'vux/src/components/x-dialog/index.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'
import Loading from 'vux/src/components/loading/index.vue'
import FormPreview from 'vux/src/components/form-preview/index.vue'

import XInput from 'vux/src/components/x-input/index'
import {fetch, promptMessage, baseUrl} from '@/api/dataHandling'
import {urlConfig} from '@/api/urlConfig'
import {getken} from '@/api/getToken'
import {getUrlParam} from '@/utils/urlUtil'

export default {
name: 'startCheck',
directives: {
TransferDom
},
components: {
XInput,
Group,
Cell,
XHeader,
Grid,
GridItem,
Divider,
Card,
XButton,
XDialog,
Loading,
FormPreview,
CheckChoice
},
data () {
return {
loadingShow: false,
show: false,
modules: {},
currentModule: {},
currentModuleIndex: 0,
queryParam: {
examinationId: undefined
},
examInfo: {},
personInfoId: '',
personInfo: {},
personResult: {},
canPre: false,
personModule: {},
showImg: '',
vip: ''
}
},
created () {
this.orgId = this.$route.query.orgId;
this.loadingShow = true
getken(this.getWechatCode) 

},
mounted () {
},
methods: {
startExam: function () {

if (!this.personInfoId) { // 未获取到个人基本信息，不加载页面

return
}
this.queryParam.examinationId = getUrlParam('id')
this.vip = getUrlParam('vip')
fetch('post', urlConfig.examSubjectGet, {
examinationId: this.queryParam.examinationId,
personInfoId: this.personInfoId
}).then(resp => {
const {examName, modules, personExams, canAnwser, examType, attention, pic, remark, end} = resp
this.examInfo.examName = examName
this.examInfo.canAnwser = canAnwser
this.examInfo.examType = examType
this.examInfo.attention = attention
this.examInfo.remark = remark
this.examInfo.end = end
this.modules = modules
if (pic) {
this.showImg = baseUrl + urlConfig.imgLook + '/crm/wechat/' + pic + '?token=' + window.localStorage.getItem('token')
}
if (this.modules) {
this.currentModule = modules[0]
}
this.setPersonExams(personExams)
this.getPersonInfo(this.personInfoId)
this.loadingShow = false
}).catch(() => {
this.loadingShow = false
})
this.loadingShow = false
},
setPersonExams (personExams) {
if (personExams.length > 0) {
this.personResult = personExams[0]
this.vip = this.personResult.vip
const {modules} = personExams[0]
this.personModule = modules
}
},
next: function () {
for (let i = 0; i < this.modules.length; i++) {
if (this.modules[i].id === this.currentModule.id) {
if (i === this.modules.length - 1) {
promptMessage('已经是最后一题了!')
break
}
this.currentModule = this.modules[++i]
this.currentModuleIndex = i

this.setAnwser()
this.setScorll()
break
}
}
},
pre: function () {
for (let i = 0; i < this.modules.length; i++) {
if (this.modules[i].id === this.currentModule.id) {
if (i === 0) {
promptMessage('已经是第一题了!')
break
}
this.currentModule = this.modules[--i]
this.currentModuleIndex = i
break
}
}
},
setAnwser: function () {

for (let i = 0; i < this.currentModule.subjects.length; i++) {
if (this.currentModule.subjects[i].choices.refSubject && !this.currentModule.subjects[i].userAnswer) {
for (let j = 0; j < this.modules.length; j++) {
for (let k = 0; k < this.modules[j].subjects.length; k++) {
if (this.currentModule.subjects[i].choices.refSubject === this.modules[j].subjects[k].choices.id) {
if (this.modules[j].subjects[k].userAnswer) {
let answerName
for (let f = 0; f < this.modules[j].subjects[k].choices.options.length; f++) {
if (this.modules[j].subjects[k].userAnswer === this.modules[j].subjects[k].choices.options[f].id) {
answerName = this.modules[j].subjects[k].choices.options[f].optionContent
}
}
for (let f = 0; f < this.currentModule.subjects[i].choices.options.length; f++) {
if (answerName === this.currentModule.subjects[i].choices.options[f].optionContent) {
this.currentModule.subjects[i].userAnswer = this.currentModule.subjects[i].choices.options[f].id
}
}
}
}
}
}
} else {
for (let j = 0; j < this.modules.length; j++) {
for (let k = 0; k < this.modules[j].subjects.length; k++) {
if (this.currentModule.subjects[i].choices.id === this.modules[j].subjects[k].choices.id) {
this.currentModule.subjects[i].userAnswer = this.modules[j].subjects[k].userAnswer
}
}
}
}
}
},
subCommit () {
this.$nextTick(() => {
this.loadingShow = true
let moduleJson = []
for (let i = 0; i < this.modules.length; i++) {
let moduleTemp = {}
moduleTemp.examinationModuleId = this.modules[i].id
for (let j = 0; j < this.modules[i].subjects.length; j++) {
let temp = {}
temp.subjectId = this.modules[i].subjects[j].subjectId
temp.anwser = this.modules[i].subjects[j].userAnswer
temp.userInput = JSON.stringify(this.modules[i].subjects[j].userInput)
if (!moduleTemp.anwsers) {
moduleTemp.anwsers = []
}
moduleTemp.anwsers.push(temp)
}
moduleJson.push(moduleTemp)
}

if (moduleJson) {
let vip = window.localStorage.getItem('startCheckVip')
fetch('post', urlConfig.examSubjectSave, {vip: vip, examType: this.examInfo.examType, examinationId: this.queryParam.examinationId, personInfoId: this.personInfoId, modules: moduleJson})
.then(resp => {
this.examInfo.canAnwser = 2
const {personExams} = resp

this.setPersonExams(personExams)
this.loadingShow = false
}).catch(() => {
promptMessage('保存失败!')
})
}
})
},
getPersonInfo (personInfoId) {
fetch('get', urlConfig.queryPersonInfo + '?personInfoId=' + personInfoId).then(response => {
this.personInfo = response
}).catch(() => {
})
},
getPersonInfoId (openId) {
fetch('get',urlConfig.GetSfzh + '?openid=' + openId).then(response => {
const {sfzh} = response
if (sfzh) {
fetch('post', urlConfig.GetPersonInfoId + '?sfzh=' + sfzh).then(response => {
this.personInfoId = response.personInfoId
this.startExam() 
}).catch(() => {
})
} else {
promptMessage('获取院内个人基本信息失败!')
}
}).catch(() => {
})
},
getOpenId (code) {
let hosCode = window.localStorage.getItem('hosCode')
axios.get(urlConfig.getweixinOpenid + code + '&hosCode=' + hosCode).then(response => {
const {data} = response
const {resultMsg, openid} = data
if (openid) {
window.localStorage.setItem('startCheckOpenid', openid)
this.getPersonInfoId(openid)
} else {
promptMessage(resultMsg)
}
})
},
getWechatCode () {
this.loadingShow = true
let _this = this
let openId = window.localStorage.getItem('startCheckOpenid')
if(this.$route.query.openid){
openId = this.$route.query.openid
}
let vip = _this.$route.query.vip
window.localStorage.setItem('startCheckVip', vip)
if (openId) {
this.getPersonInfoId(openId)
return
}
const code = getUrlParam('code')
if (code) {
_this.getOpenId(code)
return
}
let hosCode = _this.$route.query.hosCode
window.localStorage.setItem('hosCode', hosCode)
axios.get(urlConfig.getsigninfo + encodeURIComponent(window.location.href) + '&hosCode=' + hosCode + '&vip=' + vip).then(response => {
const {data} = response
window.location.href = 'https://open.weixin.qq.com/connect/oauth2/authorize?appid=' + data.appId + '&redirect_uri=' + encodeURIComponent(location.href) + '&response_type=code&scope=snsapi_base&state=1#wechat_redirect'
})
},
setScorll () {
this.$nextTick(() => {

window.scrollTo(0, 0)
})
}
}
}



// WEBPACK FOOTER //
// ./src/project/exam/startCheck.vue